import React from 'react';
import { useRecoilState } from 'recoil';
import {
  Box,
  Divider,
  IconButton,
  Stack,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { isVisibleTireState, isVisibleWheelhouseState } from 'features/three-view/state/threeAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  subtitle: string;
};

const iconSx = {
  fontSize: 12,
  color: '#e1e1e1'
};

const boxSx = {
  backgroundColor: '#404040',
  borderRadius: '5px',
  height: '80%',
  overflow: 'auto',
  padding: 1,
};

export const DisplayOthersPanel: React.FC<Props> = ({ subtitle }) => {
  const [isVisibleTire, setisVisibleTire] = useRecoilState(isVisibleTireState);
  const [isVisibleWheelhouse, setisVisibleWheelhouse] = useRecoilState(isVisibleWheelhouseState);

  const handleTireToggle = () => setisVisibleTire((prev) => !prev);
  const handleWheelhouseToggle = () => setisVisibleWheelhouse((prev) => !prev);

  return (
    <Box component="div" sx={{ height: '100%', width: '100%' }}>
      <Box component="div" sx={{ display: 'flex', alignItems: 'center', height: '8%' }}>
        <CustomTypography>{subtitle}</CustomTypography>
      </Box>

      <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />

      <Box component="div" sx={boxSx}>
        <Stack direction="column">
          <Box component="div" sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={handleTireToggle}>
              {isVisibleTire ? <VisibilityIcon sx={iconSx} /> : <VisibilityOffIcon sx={iconSx} />}
            </IconButton>
            <CustomTypography>All Tires</CustomTypography>
          </Box>

          <Box component="div" sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={handleWheelhouseToggle}>
              {isVisibleWheelhouse ? <VisibilityIcon sx={iconSx} /> : <VisibilityOffIcon sx={iconSx} />}
            </IconButton>
            <CustomTypography>All Wheelhouses</CustomTypography>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
